import { memo } from 'react';
import { Element } from 'uinix-ui';

import { SharedBoxProps } from '../../types/SharedBoxProps';
import { transformProps } from './utils/transformProps';

export const Box = memo((props: SharedBoxProps) => {
  const transformedProps = transformProps(props);

  return <Element {...transformedProps} />;
});
